import React, { useEffect } from "react";
import "./Game_History.css";
import CustomPagination from "../../../Common/Common_Component/CustomPagination/CustomPagination";
import { GetAllPeriodHistory } from "../../../../features/games/color_prediction/Slice";
import { useDispatch, useSelector } from "react-redux";
import { transformGameData } from "../../../../utils/common";
import { useSocket } from "../../../../utils/socket";

function Game_History({ mainActiveTab }) {
  const gameData = [
    { period: "123456789012", number: 1, size: "Small", color: ["green"] },
    { period: "123456789012", number: 2, size: "Small", color: ["red"] },
    { period: "123456789012", number: 4, size: "Small", color: ["red"] },
    {
      period: "123456789012",
      number: 5,
      size: "Big",
      color: ["green", "purple"],
    },
    { period: "123456789012", number: 7, size: "Big", color: ["green"] },
    { period: "123456789012", number: 9, size: "Big", color: ["green"] },
    { period: "123456789012", number: 6, size: "Big", color: ["red"] },
    { period: "123456789012", number: 8, size: "Big", color: ["red"] },
    {
      period: "123456789012",
      number: 0,
      size: "Small",
      color: ["red", "purple"],
    },
    { period: "123456789012", number: 9, size: "Big", color: ["green"] },
  ];

  const dispatch = useDispatch();

  const periodHistory = useSelector((state) => state.games.color_prediction);

  const fetch = async (page) => {
    await dispatch(GetAllPeriodHistory({
      page,
      option_id: mainActiveTab?.option_id
    }))
  }


  useEffect(() => {
    fetch(1)
  }, [dispatch, mainActiveTab])



  const newGameData = transformGameData(periodHistory?.data);

  console.log({ periodHistory: periodHistory });


  const handlePageChange = async (page) => {
    fetch(page)
  };

  // useSocket(`color_prediction_result_${mainActiveTab?.id}sec`, (data) => {
  //   setTimeout(() => {
  //     fetch(1);

  //   }, 5000);
  // });

  return (
    <>
      <section className="Game_History">
        <div className="table_wrapper">
          <table>
            <thead>
              <tr>
                <th>Period</th>
                <th>Number</th>
                <th>Big / Small</th>
                <th>Color</th>
              </tr>
            </thead>

            <tbody>
              {newGameData.map((item, index) => (
                <tr key={index}>
                  <td>{item.period}</td>

                  <td className={item.color?.length > 1 ? `number ${item.color[0]}_${item.color[1]}` : `number ${item.color[0]}`}>{item.number}</td>

                  <td>{item.size}</td>

                  <td>
                    <div className="color_dots">
                      {item.color.map((clr, i) => (
                        <span key={i} className={`dot ${clr}`}></span>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section >
      {periodHistory?.data?.length > 0 &&
        <CustomPagination
          currentPage={periodHistory?.period_pagination?.current_page}
          totalPages={periodHistory?.period_pagination?.total_pages}
          handlePageChange={handlePageChange}
        />
      }
    </>
  );
}

export default Game_History;
